@if ((formCtrl().errors?.['maxlength'] || formCtrl().errors?.['max']) && (formCtrl().dirty || formCtrl().touched)) {
  <small class="error-info text-error">
    {{ formCtrl().errors?.['maxlength'] ? errorMsg : errorValue }}
  </small>
}
